import AsyncStorage from '@react-native-async-storage/async-storage';

const PREFIX = 'doc_download_';

export interface CachedDocument {
  localUri: string;
  filename: string;
}

export async function getCachedDocument(messageId: string): Promise<CachedDocument | null> {
  try {
    const raw = await AsyncStorage.getItem(PREFIX + messageId);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CachedDocument;
    if (parsed?.localUri && parsed?.filename) return parsed;
  } catch (_) {}
  return null;
}

export async function setCachedDocument(messageId: string, data: CachedDocument): Promise<void> {
  try {
    await AsyncStorage.setItem(PREFIX + messageId, JSON.stringify(data));
  } catch (_) {}
}
